import { ModalsSlice, UsersSlice } from '@hefe/store';
import { Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface ActivateUsersFormProps {
  userIds: number[];
}

export default function ActivateUsersForm(props: ActivateUsersFormProps) {
  const dispatch = useAppDispatch();

  const submit = () => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setLoading(true));
    dispatch(UsersSlice.activateUsers(props.userIds))
      .unwrap()
      .then(() => dispatch(ModalsSlice.modalsActions.closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <Space direction="vertical">
      <Typography.Paragraph>
        {t('questions.activate_users')}
      </Typography.Paragraph>
      <CustomForm
        key="activate-users"
        formId="activate-users"
        fields={[]}
        onSubmit={submit}
      />
    </Space>
  );
}
